function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShareFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 25 25"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12.5.396C5.81.396.335 5.87.335 12.56c0 6.022 4.38 11.01 10.158 12.043l.072-.059-.011-.001v-8.577H7.512v-3.406h3.042V9.884c0-3.04 1.946-4.744 4.744-4.744.852 0 1.825.122 2.676.243v3.102h-1.581c-1.46 0-1.825.73-1.825 1.704v2.372h3.224l-.548 3.406h-2.676v8.577c-.039.007-.077.009-.116.015l.055.045c5.779-1.034 10.158-6.021 10.158-12.043C24.665 5.87 19.191.396 12.5.396Z",
  style: {
    fill: "inherit"
  }
}));
export default SvgShareFacebook;